module.exports = __webpack_public_path__ + "img/m6-.prt.5061837d.jpg";